import React, { useState } from 'react';
import { ConfirmationModal, TextField, Typography, useGlobalContext } from 'seagull';
import { getPMDetails } from "../../PracticeManagement/pm.utils";
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { getHelpArticle, handleRequest } from "../../../infra/utils";
import styles from "./APIKeyModal.module.scss";
const APIKeyModal = _ref => {
  let {
    pmName,
    apiKeyListener,
    dismissModal
  } = _ref;
  const [apiKey, setApiKey] = useState('');
  const globalContext = useGlobalContext();
  const handleChange = e => {
    setApiKey(e.target.value);
  };
  return /*#__PURE__*/React.createElement(ConfirmationModal, {
    title: "Set API key",
    "data-testid": "".concat(getPMDetails(pmName).nameForTestID, "-set-api-key-modal"),
    textAlignCenter: false,
    width: "640px",
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "To integrate with ".concat(getPMDetails(pmName).name, ", copy your API key from the Anchor integration page in your ").concat(getPMDetails(pmName).name, " account and paste it into the field below. "), /*#__PURE__*/React.createElement(ExternalLinkButton, {
      href: getHelpArticle(getPMDetails(pmName).articleLink),
      "data-testid": 'learn-more-link',
      openInNewTab: true
    }, "Learn more")), /*#__PURE__*/React.createElement("div", {
      className: styles.textfield
    }, /*#__PURE__*/React.createElement(TextField, {
      onChange: handleChange,
      "data-testid": "".concat(getPMDetails(pmName).nameForTestID, "-set-api-key-input")
    }))),
    primaryButtonLabel: "Set",
    onPrimaryButtonClick: async () => {
      globalContext.startLoader('SetAPIKey');
      const {
        success
      } = await handleRequest(apiKeyListener.saveApiKey(apiKey));
      globalContext.stopLoader('SetAPIKey');
      if (!success) {
        globalContext.showErrorToast('Failed to set API key. Please check the key and try again.', "".concat(getPMDetails(pmName).nameForTestID, "-set-api-key-failed"));
      } else {
        dismissModal();
      }
    },
    secondaryButtonLabel: "Cancel",
    onSecondaryButtonClick: () => dismissModal(),
    primaryButtonTestid: "".concat(getPMDetails(pmName).nameForTestID, "-set-api-key-submit"),
    secondaryButtonTestid: "".concat(getPMDetails(pmName).nameForTestID, "-set-api-key-cancel")
  });
};
export default APIKeyModal;